module.exports = __webpack_public_path__ + "img/image-family.134a2f06.jpg";